import { render, staticRenderFns } from "./CategoryTile.vue?vue&type=template&id=9f44bc42&scoped=true&"
import script from "./CategoryTile.vue?vue&type=script&lang=js&"
export * from "./CategoryTile.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTile.vue?vue&type=style&index=0&id=9f44bc42&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f44bc42",
  null
  
)

export default component.exports